import styles from './Toast.module.scss'
import Icon from '../Icon/Icon'

export type SaveStatus = 'success' | 'error' | 'email-sent' | 'success-unsubscribed' | null

const Toast = ({ status, message }: { status: SaveStatus; message?: string }) => {
  if (status === 'success' || status === 'success-unsubscribed')
    return (
      <div className={styles['toast-success']}>
        <Icon name="checkmark" />
        {status === 'success'
          ? (message ?? 'Der Newsletter wurde erfolgreich abonniert')
          : 'Der Newsletter wurde erfolgreich abbestellt'}
      </div>
    )
  if (status === 'error')
    return (
      <div className={styles['toast-error']}>
        <Icon name="close" />
        {message ?? 'Die Verbindung zum Server wurde unterbrochen, bitte versuchen Sie es erneut.'}
      </div>
    )
  if (status === 'email-sent')
    return (
      <div className={styles['toast-success']}>
        <Icon name="checkmark" />
        Eine E-Mail wurde an Sie versendet. Bitte öffnen Sie den Link in der Nachricht.
      </div>
    )
  return null
}

export default Toast
